module.exports = __webpack_public_path__ + "static/media/onboarding-wellness-results.57c1017b.svg";